/**
 * The five reasons a report can give, in the order the dialog lists them.
 *
 * The values are the server's (`moderation/models.py`, and its CHECK); the
 * labels are W8, Josh's words (2026-09-24), and the only words anybody sees
 * for them — in the report dialog and in the admin queue, which used to print
 * the slug (Q28).
 */
export const REPORT_REASONS = [
  { value: 'abuse', label: 'Abusive or hateful' },
  { value: 'spam', label: 'Spam' },
  { value: 'spoiler', label: 'Contains spoilers' },
  { value: 'catalog', label: 'Filed under the wrong album or song' },
  { value: 'other', label: 'Something else' },
]

/** The label for a reason, or the slug itself for one this list does not know. */
export function reasonLabel(value) {
  return REPORT_REASONS.find((reason) => reason.value === value)?.label ?? value
}
